module.exports = __webpack_public_path__ + "static/media/replace.6bdd2504.svg";